module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAaCAYAAACtv5zzAAAAAXNSR0IArs4c6QAAAP5JREFUSEtjZKAxYKSx+QyjFhAM4dEgGqRBFJpWzv/ry5d+Bob/lzcum9aPy5mhDQ1sv2+9Kv/PyHB949Jpa7CpwxrJ/lGZa/7/ZwgGaWBkYuzYuHRaJbpmkOG/br5c/Z+BwQ8sx8zgs2nJ9K3o6nBYkDX9////GTDF6JZgGA52CHP0xqVTlhFlQVraTNYXXy6uZvj/3x/dEmyGMzAwtW9aPrWK6CACKcRuCUM3wz8GdXiwgE3EbTg4iPGlM2yWoKrHbzhBC3D5BGIJYcOJsgBmycvPF9YggoY4w4m2AKQQHLm3XjYxMDI93rh06lSCWRiqYLSwIxhSo0E0AoIIAGFMeBslN/5tAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/open-province.png
// module id = 216
// module chunks = 1